import { render, staticRenderFns } from "./HelpDialog.vue?vue&type=template&id=96210a16"
import script from "./HelpDialog.vue?vue&type=script&lang=js"
export * from "./HelpDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports